import {UserBlockDomain} from "../../domain/user/UserBlockDomain"
import {UserBlockId} from "../../id/user/UserBlockId"
import {UserBlockReasonId} from "../../id/user/UserBlockReasonId"
import {UserId} from "../../id/user/UserId"
import {ValueObject} from "ts-protocol-extension"

/**
 * 사용자 이용 정지
 */
export class UserBlockValueObject implements ValueObject, UserBlockDomain {
    /**
     * 기본키
     */
    id: UserBlockId
    /**
     * 생성자 ID
     */
    creatorId: UserId
    /**
     * 사용자 ID
     */
    userId: UserId
    /**
     * 사용자 이용 정지 사유 ID
     */
    userBlockReasonId: UserBlockReasonId
    /**
     * 이용 정지 시작일
     */
    blockedAt: Date
    /**
     * 이용 정지 종료일
     */
    blockedUntil?: Date
    /**
     * 생성일
     */
    createdAt: Date
    /**
     * 마지막 수정일
     */
    lastModifiedAt?: Date

    constructor(o: Record<keyof UserBlockDomain, any>) {
        this.id = BigInt(o.id)
        this.creatorId = BigInt(o.creatorId)
        this.userId = BigInt(o.userId)
        this.userBlockReasonId = BigInt(o.userBlockReasonId)
        this.blockedAt = new Date(o.blockedAt)
        if (o.blockedUntil !== undefined && o.blockedUntil !== null) {
            this.blockedUntil = new Date(o.blockedUntil)
        }
        this.createdAt = new Date(o.createdAt)
        if (o.lastModifiedAt !== undefined && o.lastModifiedAt !== null) {
            this.lastModifiedAt = new Date(o.lastModifiedAt)
        }
    }
}
